import { ArrowUpRight, Instagram, Music2 } from "lucide-react";

export const formatNumber = (n) => n >= 1000000 ? `${(n/1000000).toFixed(1)}M` : n >= 1000 ? `${(n/1000).toFixed(0)}K` : n;
export const money = (n) => `$${Number(n || 0).toLocaleString()}`;

export function PageHeader({ eyebrow, title, description, action }) {
  return <header className="page-header" data-testid={`${eyebrow.toLowerCase().replaceAll(" ", "-")}-page-header`}>
    <div><span className="eyebrow" data-testid="page-eyebrow">{eyebrow}</span><h1 data-testid="page-title">{title}</h1><p data-testid="page-description">{description}</p></div>{action}
  </header>;
}

export function PlatformBadge({ platform, testId }) {
  return <span className={`platform-badge ${platform.toLowerCase()}`} data-testid={testId || `platform-${platform.toLowerCase()}-badge`}>
    {platform === "Instagram" ? <Instagram size={13}/> : <Music2 size={13}/>} {platform}
  </span>;
}

export function StatCard({ label, value, change, icon: Icon, tone="cyan" }) {
  const slug=label.toLowerCase().replaceAll(" ", "-");
  return <article className={`stat-card tone-${tone}`} data-testid={`stat-${slug}`}>
    <div className="stat-top"><span data-testid={`stat-${slug}-label`}>{label}</span><Icon size={19}/></div>
    <strong data-testid={`stat-${slug}-value`}>{value}</strong>{change && <small data-testid={`stat-${slug}-change`}><ArrowUpRight size={13}/>{change}</small>}
  </article>;
}

export function EmptyState({ title, body }) { return <div className="empty-state" data-testid="empty-state"><strong data-testid="empty-state-title">{title}</strong><p data-testid="empty-state-body">{body}</p></div>; }

export function Loading() { return <div className="loading-wrap" data-testid="page-loading"><span className="loader"/><span>Loading workspace</span></div>; }